var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { getCrmExamineCount } from '@/api/examine';
import { getMyInitiateCount } from '@/api/oa/examine';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
var ExamineTab = /** @class */ (function (_super) {
    __extends(ExamineTab, _super);
    function ExamineTab() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.status = [{
                name: '我发出的审批',
                value: 'my',
                count: 0,
            }, {
                name: '待我审批（合同）',
                value: 'contract',
                count: 0,
            }, {
                name: '待我审批（回款）',
                value: 'receivables',
                count: 0,
            }, {
                name: '待我审批（发票）',
                value: 'invoice',
                count: 99,
            }];
        _this.active = 'my';
        return _this;
    }
    ExamineTab.prototype.mounted = function () {
        this.updateTabCount();
        this.$bus.on('tab-count-change', this.updateTabCount);
    };
    ExamineTab.prototype.indexChange = function (val) {
        this.active = val;
    };
    ExamineTab.prototype.changeHandle = function () {
        this.$emit('update:index', this.active);
        this.$emit('change', this.active);
    };
    ExamineTab.prototype.updateTabCount = function () {
        var _this = this;
        getMyInitiateCount({ categoryId: '', status: '0' }).then(function (res) {
            var _a;
            _this.status[0].count = ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.sendCount) || 0;
        });
        getCrmExamineCount({ status: '1' }).then(function (res) {
            var _a = res === null || res === void 0 ? void 0 : res.data, _b = _a.receivedContractCount, receivedContractCount = _b === void 0 ? 0 : _b, _c = _a.receivedReceivablesCount, receivedReceivablesCount = _c === void 0 ? 0 : _c, _d = _a.receivedInvoiceCount, receivedInvoiceCount = _d === void 0 ? 0 : _d;
            _this.status[1].count = receivedContractCount;
            _this.status[2].count = receivedReceivablesCount;
            _this.status[3].count = receivedInvoiceCount;
        });
    };
    __decorate([
        Prop({
            type: String,
            default: 'my',
        })
    ], ExamineTab.prototype, "index", void 0);
    __decorate([
        Watch('index', {
            immediate: true,
        })
    ], ExamineTab.prototype, "indexChange", null);
    ExamineTab = __decorate([
        Component
    ], ExamineTab);
    return ExamineTab;
}(Vue));
export default ExamineTab;
